// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chat-message"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M2.5 3L21.5 3L21.5 17L6.5 17L2.5 20.5L2.5 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2.5 3L21.5 3L21.5 17L6.5 17L2.5 20.5L2.5 3Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M7.00391 10L7 10L7 9.99609L7.00391 9.99609L7.00391 10Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M12.0039 10L12 10V9.99609L12.0039 9.99609V10Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M17.0039 10L17 10V9.99609L17.0039 9.99609V10Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-chat-message')
export default class ChatMessageIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-message',
    }
  }
}
